import React from 'react';
import Link from 'next/link';

const Blogsrecents = () => {
  return (
    <div className="columns comments shadow-lg">
    <span className="title"> <h2 className='text-[#000]'>Recent Comments</h2>  <Link href="#" title="Explore More"></Link></span>
    <section className=''>
      <marquee
        className="marquee2">
        <p>Remember, torn clothes should not be left at home. Dispose of them out. Buying new clothes like towels.</p>
        <p>wearing clothes, bedsheets are like inviting good luck to the home.</p>
        <p>Arrange doormats before every door and please change the doormats once in 6/8 months or maximum within 1 year. For More Daily</p>
      </marquee>
    </section>
  </div>
  )
}

export default Blogsrecents